var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        !_vm.notModal ? "v-dialog" : "div",
        {
          tag: "component",
          attrs: {
            "max-width": "1200px",
            persistent: "",
            "content-class": !_vm.notModal
              ? "sb-modal sb-modal--external-filter"
              : undefined
          },
          model: {
            value: _vm.showFilterDialog,
            callback: function($$v) {
              _vm.showFilterDialog = $$v
            },
            expression: "showFilterDialog"
          }
        },
        [
          _c(
            "v-card",
            {
              ref: "externalFilterCard",
              staticClass: "exteranl-filter-card",
              class: _vm.moduleName
            },
            [
              !_vm.notModal
                ? _c(
                    "v-card-title",
                    [
                      _c(
                        "v-layout",
                        { staticClass: "align-center" },
                        [
                          _c("v-flex", [
                            _c("h4", { staticClass: "sb-modal-title" }, [
                              _vm._v("Advanced Filters")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "sb-modal-close",
                              on: { click: _vm.closeFilterDialog }
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-text",
                { class: { "not-modal": _vm.notModal } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.selectedFilterText) + "\n        "
                  ),
                  _c(
                    "v-form",
                    {
                      model: {
                        value: _vm.validForm,
                        callback: function($$v) {
                          _vm.validForm = $$v
                        },
                        expression: "validForm"
                      }
                    },
                    [
                      _c("kFilter", {
                        attrs: {
                          fields: _vm.columnFields,
                          value: _vm.filter,
                          "default-group-filter": _vm.defaultGroupFilter
                        },
                        on: { change: _vm.onFilterChange },
                        scopedSlots: _vm._u([
                          {
                            key: "customDateFilter",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c("custom-date-filter", {
                                  ref: "date-filter-input",
                                  attrs: {
                                    "filter-obj": props.filter,
                                    "not-modal": "",
                                    "date-format": _vm.columnFields.find(
                                      function(f) {
                                        return f.name == props.filter.field
                                      }
                                    ).format
                                  },
                                  on: {
                                    "filter-change": function($event) {
                                      _vm.filterApplied = false
                                    },
                                    "valid-date": function(v) {
                                      _vm.validDateFilter = v
                                    }
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "customNumericFilter",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c("custom-filter-input", {
                                  attrs: {
                                    "filter-obj": props.filter,
                                    "not-modal": "",
                                    "filter-input-type": "number"
                                  },
                                  on: {
                                    "filter-change": function($event) {
                                      _vm.filterApplied = false
                                    }
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "customBooleanFilter",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c("custom-filter-input", {
                                  attrs: {
                                    "filter-obj": props.filter,
                                    "not-modal": "",
                                    "filter-input-type": "boolean"
                                  },
                                  on: {
                                    "filter-change": function($event) {
                                      _vm.filterApplied = false
                                    }
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "customTextFilter",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c("custom-filter-input", {
                                  attrs: {
                                    "filter-obj": props.filter,
                                    "not-modal": "",
                                    "filter-input-type": "text"
                                  },
                                  on: {
                                    "filter-change": function($event) {
                                      _vm.filterApplied = false
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          staticClass: "my-2 filter-btns justify-end",
                          attrs: { row: "" }
                        },
                        [
                          !_vm.notModal
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "sb-btn-outline-neutral",
                                  attrs: { depressed: "" },
                                  on: { click: _vm.closeFilterDialog }
                                },
                                [_vm._v("\n              Cancel\n            ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "sb-btn-primary",
                              class: {
                                "mt-0 ml-1": _vm.notModal,
                                "ml-2": !_vm.notModal
                              },
                              attrs: {
                                depressed: "",
                                disabled:
                                  (_vm.filter.filters.length == 0 &&
                                    !_vm.notModal) ||
                                  !_vm.validFilter
                              },
                              on: { click: _vm.applyExternalFilters }
                            },
                            [
                              _vm.notModal
                                ? _c("span", [_vm._v("Refresh Sample Data")])
                                : _c("span", [
                                    _vm.filterApplied
                                      ? _c("span", [_vm._v("Applied")])
                                      : _vm._e(),
                                    !_vm.filterApplied
                                      ? _c("span", [_vm._v("Apply")])
                                      : _vm._e()
                                  ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }